/**
 * 리소스 힌트 유틸리티
 * 브라우저가 리소스를 미리 로드하거나 연결을 설정하도록 힌트를 제공합니다.
 */

// 중요한 리소스들을 프리로드
export const setupResourceHints = () => {
  // Supabase API 연결 최적화
  addPreconnect('https://yxlgjkwlqogjzcdvbsum.supabase.co');
  
  // CDN 연결 최적화
  addDnsPrefetch('https://cdn.jsdelivr.net');
  
  // 폰트 CDN (사용하는 경우)
  addDnsPrefetch('https://fonts.googleapis.com');
  addDnsPrefetch('https://fonts.gstatic.com');
  
  // Analytics/Tracking (사용하는 경우)
  addDnsPrefetch('https://www.googletagmanager.com');
  addDnsPrefetch('https://www.google-analytics.com');
};

// Preconnect 추가
const addPreconnect = (href: string) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  link.crossOrigin = 'anonymous';
  
  // 중복 체크
  const existing = document.querySelector(`link[rel="preconnect"][href="${href}"]`);
  if (!existing) {
    document.head.appendChild(link);
  }
};

// DNS Prefetch 추가
const addDnsPrefetch = (href: string) => {
  const link = document.createElement('link');
  link.rel = 'dns-prefetch';
  link.href = href;
  
  // 중복 체크
  const existing = document.querySelector(`link[rel="dns-prefetch"][href="${href}"]`);
  if (!existing) {
    document.head.appendChild(link);
  }
};

// Prefetch 추가 (다음에 방문할 가능성이 높은 페이지)
export const prefetchRoute = (href: string) => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = href;
  
  // 중복 체크
  const existing = document.querySelector(`link[rel="prefetch"][href="${href}"]`);
  if (!existing) {
    document.head.appendChild(link);
  }
};

// Preload 추가 (현재 페이지에서 곧 필요한 리소스)
export const preloadResource = (href: string, as: string, type?: string) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = href;
  link.as = as;
  
  if (type) {
    link.type = type;
  }
  
  if (as === 'font') {
    link.crossOrigin = 'anonymous';
  }
  
  // 중복 체크
  const existing = document.querySelector(`link[rel="preload"][href="${href}"]`);
  if (!existing) {
    document.head.appendChild(link);
  }
};

export default {
  setupResourceHints,
  prefetchRoute,
  preloadResource
};